import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setTechnologyIntegrationPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useTechnologyProductIntegrationSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getTechProductIntegrationSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.technology_integration_page?.technology_integration_section}`);
      console.log("🚀 ~ getTechProductIntegrationSectionJson ~ data:", response);
      console.log("🚀 ~ getTechProductIntegrationSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setTechnologyIntegrationPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Technology Product Integration section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getTechProductIntegrationSectionJson();
  }, [getTechProductIntegrationSectionJson]);

  return {
    data,
    loading,
    error,
    getTechProductIntegrationSectionJson,
    fetchOnMount,
    refetch: getTechProductIntegrationSectionJson
  };
};

export default useTechnologyProductIntegrationSection;
